import { Col, Row } from "antd";
import axios from "axios";
import React from "react";
import { ListItemLayoutDefault } from "../../list/ListItem.Layout";
import { ListItemProps, ListV2 } from "../../list/ListV2";
import { SearchRequest } from "../../model/search/UserSearchRequestV1";
import { PageResponse } from "../../paging/Paging.Model";
import { TextViewComponent } from "../common/TextView";

interface AppLog {
  id: number;
  content: string;
  category: string;
  subCategory: string;
  createdAt: string;
}

const MAX_CONTENT_LENGTH = 200;

export function AdminAppLogsPage() {
  const onFetch = (
    searchRequest?: SearchRequest
  ): Promise<PageResponse<AppLog>> => {
    const page = searchRequest?.pageParams?.page ?? 0;
    const size = searchRequest?.pageParams?.size ?? 10;
    return axios
      .get(`/api/admin/app-logs?page=${page}&size=${size}`)
      .then((res) => {
        const pageResponse: PageResponse<AppLog> = {
          content: res.data.content,
          totalSize: res.data.totalElements,
        };
        return pageResponse;
      });
  };

  const itemNode = (props: ListItemProps) => {
    const log = props.item as AppLog;
    return (
      <div className="p-3">
        <Row>
          <Col>
            <strong>ID:</strong> {log.id}
          </Col>
        </Row>
        <Row>
          <Col>
            <strong>Timestamp: </strong>

            {new Date(log.createdAt).toLocaleString()}
          </Col>
        </Row>
        <Row>
          <Col>
            <strong>Category:</strong> {log.category}
          </Col>
        </Row>
        <Row>
          <Col>
            <strong>SubCategory:</strong> {log.subCategory}
          </Col>
        </Row>
        <Row>
          <Col>
            <strong>Content:</strong>
            {log.content && (
              <TextViewComponent
                text={log.content}
                maxLength={MAX_CONTENT_LENGTH}
                showMoreButton={true}
                showCopyButton={true}
              />
            )}
          </Col>
        </Row>
      </div>
    );
  };

  return (
    <div className="main-container">
      <h1>App Logs</h1>
      <ListV2
        onFetch={onFetch}
        ItemLayoutComponent={ListItemLayoutDefault}
        itemNode={itemNode}
        paginationPosition="bottom"
      />
    </div>
  );
}
